export default "__VITE_ASSET__g082JCN7__"